var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 5C3.75 6.32608 4.27678 7.59785 5.21447 8.53553C6.15215 9.47322 7.42392 10 8.75 10C10.0761 10 11.3479 9.47322 12.2855 8.53553C13.2232 7.59785 13.75 6.32608 13.75 5C13.75 3.67392 13.2232 2.40215 12.2855 1.46447C11.3479 0.526784 10.0761 0 8.75 0C7.42392 0 6.15215 0.526784 5.21447 1.46447C4.27678 2.40215 3.75 3.67392 3.75 5ZM7.44141 12.8203L8.16797 14.0312L6.86719 18.8711L5.46094 13.1328C5.38281 12.8164 5.07812 12.6094 4.76172 12.6914C2.02734 13.375 0 15.8516 0 18.8008C0 19.4648 0.539063 20 1.19922 20H6.34766C6.34766 20 6.34766 20 6.35156 20H6.5625H10.9375H11.1523C11.1523 20 11.1523 20 11.1562 20H16.3008C16.9648 20 17.5 19.4609 17.5 18.8008C17.5 15.8516 15.4727 13.375 12.7383 12.6914C12.4219 12.6133 12.1172 12.8203 12.0391 13.1328L10.6328 18.8711L9.33203 14.0312L10.0586 12.8203C10.3086 12.4023 10.0078 11.875 9.52344 11.875H8.75H7.98047C7.49609 11.875 7.19531 12.4062 7.44531 12.8203H7.44141Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.03e1ac4d3e798a3a90f0627716b3080c.svg";
export { ForwardRef as ReactComponent };